/*!
 * ymm-widget.js — cascading Make → Family → Model → Year dropdown picker (+ optional VIN box).
 * Vanilla, no deps. Resolves against the LOCAL dataset via window.YMM (no network). Adapted from the
 * portable ymm.js: same shape, but get()→YMM.* instead of fetch(api.php).
 *   new YMMWidget(el, { onApply, vin, compact })
 *     onApply(vehicle)  — called with the canonical vehicle when the shopper applies a pick / decodes a VIN
 */
(function (w) {
  'use strict';
  // YEAR-FIRST cascade, matching the source engine and the visual drill-down.
  var AXES = ['year', 'make', 'family', 'model'];
  var LABELS = { year: 'Year', make: 'Make', family: 'Family', model: 'Model' };

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  // make names come from our own data, but this message is built with innerHTML — escape anyway
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function YMMWidget(mount, opts) {
    this.el = typeof mount === 'string' ? document.querySelector(mount) : mount;
    this.opts = opts || {};
    this.sel = {};
    if (!this.el) return;
    this.render();
    var self = this;
    w.YMM.onReady(function () { self.fill('year'); });
  }

  YMMWidget.prototype.render = function () {
    var self = this;
    this.el.classList.add('ymm-widget');
    if (this.opts.compact) this.el.classList.add('ymm-widget--compact');
    var row = el('div', 'ymm-row');
    this.selects = {};
    AXES.forEach(function (axis) {
      var s = el('select', 'ymm-sel');
      s.setAttribute('data-axis', axis);
      s.setAttribute('aria-label', LABELS[axis]);
      s.disabled = axis !== 'year';
      s.innerHTML = '<option value="">' + LABELS[axis] + '</option>';
      s.addEventListener('change', function () { self.onChange(axis, s.value); });
      self.selects[axis] = s;
      row.appendChild(s);
    });
    this.go = el('button', 'ymm-go btn', 'Find parts');
    this.go.type = 'button'; this.go.disabled = true;
    this.go.addEventListener('click', function () { self.apply(); });
    this.clear = el('button', 'ymm-clear', 'Clear');
    this.clear.type = 'button';
    this.clear.addEventListener('click', function () { self.reset(); });
    row.appendChild(this.go); row.appendChild(this.clear);
    this.el.innerHTML = '';
    this.el.appendChild(row);

    if (this.opts.vin) {
      var vrow = el('div', 'ymm-vinrow');
      vrow.innerHTML = '<span class="ymm-or">or</span>' +
        '<input type="text" class="ymm-vin-input" maxlength="17" placeholder="Enter 17-digit VIN" autocomplete="off" spellcheck="false">' +
        '<button type="button" class="ymm-vin-go btn">Search by Vin</button>' +
        '<span class="ymm-vin-msg" role="status"></span>';
      this.el.appendChild(vrow);
      this.vinInput = vrow.querySelector('.ymm-vin-input');
      vrow.querySelector('.ymm-vin-go').addEventListener('click', function () { self.decodeVin(); });
      this.vinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.decodeVin(); } });
      this.vinMsg = vrow.querySelector('.ymm-vin-msg');
    }
  };

  YMMWidget.prototype.onChange = function (axis, value) {
    if (value) this.sel[axis] = value; else delete this.sel[axis];
    var i = AXES.indexOf(axis);
    for (var j = i + 1; j < AXES.length; j++) { delete this.sel[AXES[j]]; }  // clear downstream
    if (i + 1 < AXES.length) this.fill(AXES[i + 1]);
    this.refreshState();
  };

  // populate one select from the tree, honoring the current selection (year constrains every later axis)
  YMMWidget.prototype.fill = function (axis) {
    var s = this.selects[axis]; if (!s) return;
    var items = [];
    if (axis === 'year') items = w.YMM.years().map(function (y) { return { v: y, t: y }; });
    else if (axis === 'make' && this.sel.year) items = w.YMM.makes(this.sel.year).map(function (m) { return { v: m.key, t: m.name }; });
    else if (axis === 'family' && this.sel.make) items = w.YMM.families(this.sel.make, this.sel.year).map(function (f) { return { v: f, t: f }; });
    else if (axis === 'model' && this.sel.family) items = w.YMM.models(this.sel.make, this.sel.family, this.sel.year).map(function (m) { return { v: m, t: m }; });
    var prev = this.sel[axis];
    s.innerHTML = '<option value="">' + LABELS[axis] + '</option>' +
      items.map(function (it) { return '<option value="' + it.v + '"' + (String(prev) === String(it.v) ? ' selected' : '') + '>' + it.t + '</option>'; }).join('');
    s.disabled = items.length === 0;
    // reset downstream selects visually
    var i = AXES.indexOf(axis);
    for (var j = i + 1; j < AXES.length; j++) { var d = this.selects[AXES[j]]; d.disabled = true; d.innerHTML = '<option value="">' + LABELS[AXES[j]] + '</option>'; }
  };

  YMMWidget.prototype.refreshState = function () {
    this.go.disabled = !(this.sel.make && this.sel.model && this.sel.year);
  };

  YMMWidget.prototype.vehicle = function () {
    return w.YMM.buildVehicle({ make: this.sel.make, family: this.sel.family, model: this.sel.model, year: this.sel.year });
  };

  YMMWidget.prototype.apply = function () {
    var v = this.vehicle(); if (!v) return;
    if (this.opts.onApply) this.opts.onApply(v);
  };

  YMMWidget.prototype.reset = function () {
    this.sel = {};
    var self = this;
    AXES.forEach(function (a, i) { var s = self.selects[a]; s.value = ''; if (i > 0) { s.disabled = true; s.innerHTML = '<option value="">' + LABELS[a] + '</option>'; } });
    this.refreshState();
    if (this.vinInput) { this.vinInput.value = ''; this.vinMsg.textContent = ''; }
  };

  YMMWidget.prototype.decodeVin = function () {
    var self = this;
    var raw = (this.vinInput.value || '').trim();
    if (!raw) return;
    if (!w.YMMVin) { this.vinMsg.textContent = 'VIN decoder unavailable'; return; }
    this.vinMsg.textContent = 'Decoding…'; this.vinMsg.className = 'ymm-vin-msg';
    w.YMMVin.decode(raw).then(function (env) {
      var bad = function (m) { self.vinMsg.textContent = '✗ ' + m; self.vinMsg.className = 'ymm-vin-msg is-bad'; };
      // Say what's actually wrong. This used to answer "✗ Not a Harley-Davidson VIN" to EVERYTHING that
      // wasn't a Harley — including Indian VINs, on a store that sells Indian fitment.
      // Never surface the raw warning strings — they're internal ("length 6 != 17", "illegal chars: O").
      if (!env.valid_structure) {
        if (env.status === 'invalid_length') {
          var n = (env.vin || '').length;
          bad('a VIN is 17 characters — you entered ' + n + '. Check for a missing digit.');
        } else {
          // O/I/Q are never used in a VIN precisely because they're mistaken for 0/1 — say which.
          var illegal = (env.warnings.find(function (x) { return /illegal chars/.test(x); }) || '').split(': ')[1] || '';
          bad(illegal
            ? 'a VIN never contains the letter' + (illegal.length > 1 ? 's' : '') + ' ' + illegal.split('').join(', ') +
              ' — did you mean ' + (/[O]/i.test(illegal) ? '0 (zero)' : /[I]/i.test(illegal) ? '1 (one)' : '0 (zero)') + '?'
            : "that doesn't look like a VIN — it should be 17 characters");
        }
        return;
      }
      if (env.status === 'unknown_wmi') { bad("we don't recognise that VIN's manufacturer — check it, or pick your bike below"); return; }
      if (env.status === 'unsupported_make') {
        // A real, correctly-decoded VIN for a make we don't have per-model fitment for yet. Never a dead
        // end: the bar-mount Media Screen fits any bike, so route to the universal screen-only landing.
        // TEMPORARY fallback — replaced by real per-bike fitment as tag budget allows (Media Box ~12 slots).
        var uBase = self.opts.unsupportedUrl || '/pages/carplay-for-older-motorcycles';
        var uUrl = uBase + '?make=' + encodeURIComponent(env.make_name || '') +
          (env.year ? '&year=' + encodeURIComponent(env.year) : '');
        self.vinMsg.innerHTML = 'That\'s a <strong>' + esc(env.make_name) + '</strong>' +
          (env.year ? ' (' + env.year + ')' : '') + ' — the HogPlay Media Screen fits it. Taking you there…';
        self.vinMsg.className = 'ymm-vin-msg is-ok';
        w.setTimeout(function () { w.location.href = uUrl; }, 900);
        return;
      }
      var veh = env.vehicle;
      if (!veh) { bad('could not resolve that VIN — pick your bike below'); return; }
      if (env.status === 'not_found') {
        // We know the make and year but not the model — better to say so than to guess.
        self.vinMsg.textContent = '✓ ' + [veh.year, veh.mk_name].filter(Boolean).join(' ') +
          ' — we couldn\'t pin the model from that VIN, pick it below';
        self.vinMsg.className = 'ymm-vin-msg is-warn';
        return;
      }
      self.vinMsg.textContent = '✓ ' + veh.label; self.vinMsg.className = 'ymm-vin-msg is-ok';
      if (self.opts.onApply) self.opts.onApply(veh);
    }).catch(function () { self.vinMsg.textContent = '✗ decode failed'; self.vinMsg.className = 'ymm-vin-msg is-bad'; });
  };

  w.YMMWidget = YMMWidget;
})(window);
